import { render, staticRenderFns } from "./CargoVehicleEntriesPage.vue?vue&type=template&id=62dd624b"
import script from "./CargoVehicleEntriesPage.vue?vue&type=script&lang=js"
export * from "./CargoVehicleEntriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports